import { useMemo } from "react"

import _ from "lodash"

import {
    Layer,
    MapStyles,
    ROAD_TRAFFIC_LAYER,
    ROAD_TRAFFIC_SOURCE,
    useMapStateContext,
    useOrderingLayers,
} from "@l2r-front/l2r-map"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { useTheme } from "@l2r-front/l2r-ui"

import { useSpeedingsStateContext } from "../../contexts/SpeedingsContext"
import { getRoadTrafficLayerStyle } from "../../utils/getTrafficConfig"

import { RoadTrafficSource } from "../RoadTrafficSource/RoadTrafficSource"

export function RoadTrafficLayer(props) {
    const { road } = props

    const { selectedLinearLocations } = useNetworksStateContext()
    const { getCurrentMapStyle } = useMapStateContext()
    const { currentActiveLayer, currentYear } = useSpeedingsStateContext()
    const theme = useTheme()

    const roadTrafficLayerConfig = useMemo(() => {
        const selectedRoad = selectedLinearLocations?.[0].road
        const referentialColor = getCurrentMapStyle() === MapStyles.plan ? theme.palette.map.darkReferential
            : theme.palette.map.lightReferential
        return getRoadTrafficLayerStyle(currentActiveLayer, referentialColor, theme, selectedRoad, currentYear)
    }, [currentActiveLayer, getCurrentMapStyle, theme, selectedLinearLocations, currentYear])

    useOrderingLayers([ROAD_TRAFFIC_LAYER])

    return (
        <RoadTrafficSource
            currentActiveLayer={currentActiveLayer}
            id={ROAD_TRAFFIC_SOURCE}
            tolerance={.001}
            road={road}
        >
            <Layer
                id={ROAD_TRAFFIC_LAYER}
                {...roadTrafficLayerConfig}
            />
        </RoadTrafficSource>
    )
}
